import { useQuery } from '@tanstack/react-query';

import { ZenotiService } from 'types/service';

export type GetServicesResponse = ZenotiService[];

export async function fetchServices(locationId: string | undefined) {
	const response = await fetch(`${process.env.APP_PATH}/api/get-services/?locationId=${locationId}`);
	const data = await response.json();

	if (!response.ok) {
		throw new Error(data.message);
	}

	return data as GetServicesResponse;
}

export function useGetServices(locationId: string | undefined) {
	const { error, isFetching, data } = useQuery({
		queryKey: ['getServices', locationId],
		queryFn: () => fetchServices(locationId),
		enabled: !!locationId,
	});
	return { error, isFetching, data };
}
